import { CHAVE_USUARIO, CHVAE_TOKEN } from '@/global';

export default {
    namespaced: true,
    state: {
        usuario: null,
        usuarioIKAcesso: null,
        permissoes: [],
        dadosRequisicao: null,   
        isAutenticado: false,
    },
    getters: {
        getUsuario(state) {
            return state.usuario;
        },
        getUsuarioIKAcesso(state) {
            return state.usuarioIKAcesso ? state.usuarioIKAcesso : null;
        },
        getPermissoes(state) {
            return state.permissoes;
        },
        getDadosRequisicao(state) {
            return state.dadosRequisicao;
        },
        getIsAutenticado(state) {
            return state.isAutenticado;
        }   
    },
    mutations: {
        setUsuario(state, usuario) {
            state.usuario = usuario;
        },
        setUsuarioIKAcesso(state, usuarioIKAcesso) {
            state.usuarioIKAcesso = usuarioIKAcesso;
        },
        setPermissoes(state, permissoes) {            
            state.permissoes = permissoes;            
        },
        setDadosRequisicao(state, dados) {
            state.dadosRequisicao = dados;
        },
        setIsAutenticado(state, autenticado) {
            state.isAutenticado = autenticado;
        }
    },
    actions: {
        criarSessaoIKAcesso(context, dados) {
            context.commit('setUsuarioIKAcesso', {...dados.usuarioIKAcesso});
        },
        criarSessao(context, dados) {                                   
            // Dados gerais
            sessionStorage.setItem(CHAVE_USUARIO, JSON.stringify(dados));   
            // Somente o token
            sessionStorage.setItem(CHVAE_TOKEN, JSON.stringify(dados.token));                   
            context.commit('setUsuario', {...dados.requisicao.usuario}); 
            let permissoes = dados.requisicao.permissoes;
            permissoes.push(0);
            context.commit('setPermissoes', permissoes);          
            context.commit('setDadosRequisicao', {...dados.requisicao});  
            context.commit('setIsAutenticado', true);
        },
        limparSessao(context) {
            sessionStorage.clear();
            context.commit('setUsuario', null);   
            context.commit('setUsuarioIKAcesso', null);          
            context.commit('setPermissoes', []);            
            context.commit('setDadosRequisicao', null);
            context.commit('setIsAutenticado', false);
        }  
    }
}